import React, { useState, useEffect } from "react";
import {
  motion,
  useSpring,
  useTransform,
  AnimateSharedLayout,
  AnimatePresence,
} from "framer-motion";


import styles from "./Preloader.module.css";

function Preloader({ percentage }) {

  const [animatedPercentage, setAnimatedPercentage] = useState(0);

  useEffect(() => {
    let i = animatedPercentage; // Start from the current animated percentage
    const animationInterval = setInterval(() => {
      if (i <= percentage) {
        setAnimatedPercentage(i++);
      }
    }, 20);

    return () => {
      clearInterval(animationInterval);
    };
  }, [percentage]);

  return <AnimatePresence exitBeforeEnter></AnimatePresence>;
}

export default Preloader;
